export default __webpack_public_path__ + "static/img-ef-7-ab1bd65b437e99b4e3d87cd9c72b5984.png";